import React from 'react';

const AsyncRadioTimeSlotList = React.lazy(() => import('./ListContainer'));

export const RadioTimeSlotList = () => {
  return <AsyncRadioTimeSlotList />;
};
